module.exports = __webpack_public_path__ + "static/media/Selfsovereign.79b8399a.png";